/**
 * Encrypts string using Crypto API.
 */
export async function hash(str: string): Promise<string> {
  const encoder = new TextEncoder();
  const buffer = encoder.encode(str);
  const hash = await crypto.subtle.digest('SHA-256', buffer);
  return hex(hash);
}

/**
 * Helper function to convert an ArrayBuffer to a hex string.
 */
function hex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
